const toDateInputString = (date: Date): string =>
    date.toISOString().split('T')[0];

/**
 * Mirrors the backend default:
 *   new DateTime(today.Year, today.Month, 1) — first day of the current month
 */
export const getDefaultReportStartDate = (): string => {
    const today = new Date();
    return toDateInputString(new Date(today.getFullYear(), today.getMonth(), 1));
};

/**
 * Mirrors the backend default:
 *   today.AddMonths(1) — same day next month
 */
export const getDefaultReportEndDate = (): string => {
    const today = new Date();
    return toDateInputString(new Date(today.getFullYear(), today.getMonth() + 1, today.getDate()));
};